<template>
  <mdb-container class="gp-has-header">
    <div class="text-left">
      <h3>Categories</h3>
      <div>
        <mdb-btn icon="plus-circle" rounded size="sm" @click="addNew">Add Category</mdb-btn>
      </div>
      <mdb-list-group striped>
        <mdb-list-group-item v-for="cat in categories" :key="cat.id">
          <div>
            {{ cat.name }}
            <span class="text-info">
              <small>({{ cat.groupCount }} {{ cat.groupCount == 1 ? 'Group' : 'Groups' }})</small>
            </span>
          </div>
          <div class="pull-right">
            <mdb-btn color="danger" floating size="sm" tag="a" @click="deleteCat(cat)">
              <mdb-icon icon="trash"/>
            </mdb-btn>
            <mdb-btn floating size="sm" tag="a" @click="edit(cat)">
              <mdb-icon icon="pencil"/>
            </mdb-btn>
          </div>

        </mdb-list-group-item>
      </mdb-list-group>
    </div>
    <mdb-modal v-if="showEditModal" @close="showEditModal = false">
      <mdb-modal-header :close="true" class="secondary-color text-white">
        {{ editing.id ? 'Edit Category' : 'Add Category' }}
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <mdb-input v-model="editing.name" label="Name" placeholder="Enter Name"/>
        <div>
          <mdb-btn :disabled="!editing.name" icon="save" size="sm" @click="save">Save</mdb-btn>
        </div>
      </mdb-modal-body>
    </mdb-modal>

    <yes-no-modal v-if="deleteModal" question="Are you sure you wish to remove this category?"
                  :additional-text="deleteCandidate.groupCount > 0 ? 'Tag will also be removed from ' + deleteCandidate.groupCount + (deleteCandidate.groupCount == 1 ? ' Group' : ' Groups') : ''"
                  @no="deleteModal=false" @yes="doDelete"/>

  </mdb-container>

</template>
<script>

import api from '../../services/groupsPlaceApi.js';
import YesNoModal from "../common/YesNoModal";

import {
  mdbBadge,
  mdbBreadcrumb,
  mdbBreadcrumbItem,
  mdbBtn,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbListGroup,
  mdbListGroupItem,
  mdbModal,
  mdbModalBody,
  mdbModalHeader
} from 'mdbvue';

export default {
  name: "group-categories",
  order: 1,
  components: {
    mdbBtn,
    mdbContainer,
    mdbIcon,
    mdbInput,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbListGroup,
    mdbListGroupItem,
    mdbBreadcrumb,
    mdbBreadcrumbItem,
    mdbBadge,
    YesNoModal
  },
  data() {
    return {
      categories: [],
      showEditModal: false,
      editing: null,
      saveCat: null,
      deleteCandidate: null,
      deleteModal: false
    }
  },
  mounted() {
    document.title = "Group Categories"
    this.loadData(null)
  },
  methods: {
    deleteCat(cat) {
      this.deleteCandidate = cat
      this.deleteModal = true
    },
    loadData(id) {
      this.$store.dispatch("setExecuting", true)
      let url = "/admin/groupCategory"
      api.get(url).then(
        (results) => {
          this.categories = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    doDelete() {
      this.$store.dispatch("setExecuting", true)
      this.deleteModal = false
      api.delete("/admin/groupCategory/" + this.deleteCandidate.id).then(
        (results) => {
          let loc = this.categories.indexOf(this.deleteCandidate)
          this.categories.splice(loc, 1)
          this.deleteCandidate = null
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    save() {
      this.showEditModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/groupCategory", this.editing).then(
        (results) => {
          if (this.editing.id) Object.assign(this.saveCat, results.data)
          else (this.categories.unshift(results.data))
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    addNew() {
      this.editing = {id: null, name: ""}
      this.showEditModal = true
    },
    edit(cat) {
      this.saveCat = cat
      this.editing = JSON.parse(JSON.stringify(cat));
      this.showEditModal = true
    }
  }
};

</script>

